export const HTTP_STATUS_CODE = {
  OK: 200,
}
